"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataProvider = void 0;
// @ts-nocheck
const react_1 = require("react");
const getterUtils_1 = require("../components/Common/Modals/getterUtils");
const useDataProvider = (arg) => {
    const { options, dataProvider, value, searchText, selectedOptions } = arg;
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [pageInfo, setPageInfo] = (0, react_1.useState)(null);
    const pageInfoRef = (0, react_1.useRef)(pageInfo);
    const prevSearchText = (0, react_1.useRef)(searchText);
    const prevTopOptions = (0, react_1.useRef)(selectedOptions);
    const [loadedOptions, setLoadedOptions] = (0, react_1.useState)(options || null);
    const [previousOptions, setPreviousOptions] = (0, react_1.useState)(options);
    const [valueOptions, setValueOptions] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        pageInfoRef.current = pageInfo;
    }, [pageInfo]);
    const mergeArrays = (mainArr, subArr) => {
        if (!subArr)
            return mainArr;
        let subArraysToLoad = [];
        for (const subObj of subArr) {
            const found = mainArr.find(obj => obj.value === subObj.value);
            if (!found) {
                subArraysToLoad = [...subArraysToLoad, subObj];
            }
        }
        return [...mainArr, ...subArraysToLoad];
    };
    const transformedData = (filteredData, searchTxt, selected) => {
        if (!filteredData)
            return [];
        const pathToLabel = 'label';
        let topOptions = prevTopOptions.current || [];
        if (searchTxt !== prevSearchText.current) {
            topOptions = searchTxt ? selected.filter((option) => (0, getterUtils_1.getLabel)(option, pathToLabel).toLowerCase().includes(searchTxt.toLowerCase())) : selected;
            prevSearchText.current = searchTxt;
            prevTopOptions.current = topOptions;
        }
        const rest = filteredData.filter((option) => !topOptions.find((topOption) => (0, getterUtils_1.areOptionsEqual)(option, topOption, 'value')));
        return [...topOptions, ...rest];
    };
    const clearPageInfo = (0, react_1.useCallback)(() => {
        pageInfoRef.current = null;
        setPageInfo(() => null);
    }, [pageInfo]);
    const computeOptions = (0, react_1.useCallback)((arg, reload) => {
        var _a, _b;
        if (dataProvider) {
            if ((!(pageInfoRef === null || pageInfoRef === void 0 ? void 0 : pageInfoRef.current) || ((_a = pageInfoRef === null || pageInfoRef === void 0 ? void 0 : pageInfoRef.current) === null || _a === void 0 ? void 0 : _a.hasNextPage))) {
                setLoading(true);
                const endCursor = (_b = pageInfoRef === null || pageInfoRef === void 0 ? void 0 : pageInfoRef.current) === null || _b === void 0 ? void 0 : _b.endCursor;
                dataProvider.optionsProvider({ filter: (arg === null || arg === void 0 ? void 0 : arg.filter) || '' }, endCursor, searchText).then((result) => {
                    const { items, pageInfo } = result;
                    setPageInfo(pageInfo);
                    setLoading(false);
                    setLoadedOptions(prevState => {
                        const result = (prevState && !reload) ? [...prevState, ...(items !== null && items !== void 0 ? items : [])] : (items !== null && items !== void 0 ? items : []);
                        return transformedData(result, searchText, selectedOptions);
                    });
                });
            }
        }
        else if (options) {
            const filteredData = searchText ? options.filter((option) => {
                return (0, getterUtils_1.getLabel)(option, 'label').toLowerCase().includes(searchText.toLowerCase());
            }) : options;
            setLoadedOptions(transformedData(filteredData, searchText, selectedOptions));
        }
        else {
            setLoadedOptions(null);
        }
    }, [dataProvider, options, pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.current, searchText, selectedOptions]);
    (0, react_1.useEffect)(() => {
        if (!dataProvider && options !== previousOptions) {
            setLoadedOptions(options || null);
            setPreviousOptions(options);
        }
    }, [dataProvider, options, setLoadedOptions, previousOptions]);
    (0, react_1.useEffect)(() => {
        if (value) {
            if (!loadedOptions && dataProvider) {
                dataProvider.valueOptionsProvider(value).then(options => setValueOptions(prev => 
                // S5-3028: Include existing options, for cases where an `else if (loadedOptions)` iteration completes before the promise returns.
                options.length ?
                    [...prev !== null && prev !== void 0 ? prev : [], ...options].filter(option => (Array.isArray(value) ? value.includes(option.value) : value === option.value))
                    : prev));
            }
            else if (loadedOptions) {
                setValueOptions(mergeArrays(loadedOptions, selectedOptions).filter(option => (Array.isArray(value) ? value.includes(option.value) : value === option.value)));
            }
            else {
                setValueOptions(Array.isArray(value) ? value.map(val => ({ label: `${val}`, value: val })) : [{ label: `${value}`, value }]);
            }
        }
        else {
            setValueOptions(null);
        }
    }, [value, loadedOptions, dataProvider, selectedOptions]);
    return { loading, options: loadedOptions, computeOptions, valueOptions, clearPageInfo, pageInfo };
};
exports.useDataProvider = useDataProvider;
//# sourceMappingURL=useDataProvider.js.map